import React from 'react';
import { Select } from 'components';
/*
 * If I can delete this file
 * No specific code for the client left
 */

export const LegalstartSpecialConf = {
  orgId: '6f415a91-af9a-485c-a7c9-15b0849ee551',
  panelId: '05f9708d-f0f9-458c-8df4-0f40a074b08a',
  specialFields: [
    {
      name: '__legalstartProduct',
      participantLabel: 'Produits',
      clientLabel: 'Produits',
      accessor: (p: any) =>
        Array.isArray(p.__legalstartProduct)
          ? p.__legalstartProduct.join(', ')
          : p.__legalstartProduct,
      formComponent: (props: { name: string; label: string }) => (
        <Select
          isMulti
          options={[
            'EURL',
            'SARL',
            'MARQUE',
            'SAS',
            'SCI',
            'SASU',
            'AE',
            'DISSO',
            'ASSO',
          ]}
          {...props}
        />
      ),
    },
  ],
};
